(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tropic-ambient"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!window._tropicReveal) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('tropic-in');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });

    window._tropicReveal = {
      observe: function () {
        document.querySelectorAll('.tropic-reveal:not(.tropic-in)').forEach(function (el) {
          obs.observe(el);
        });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', window._tropicReveal.observe);
    } else {
      window._tropicReveal.observe();
    }

    document.addEventListener('shopify:section:load', window._tropicReveal.observe);
  } else {
    window._tropicReveal.observe();
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tropic-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!window._tropicReveal) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('tropic-in');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });

    window._tropicReveal = {
      observe: function () {
        document.querySelectorAll('.tropic-reveal:not(.tropic-in)').forEach(function (el) {
          obs.observe(el);
        });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', window._tropicReveal.observe);
    } else {
      window._tropicReveal.observe();
    }

    document.addEventListener('shopify:section:load', window._tropicReveal.observe);
  } else {
    window._tropicReveal.observe();
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tropic-editorial"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!window._tropicReveal) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('tropic-in');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });

    window._tropicReveal = {
      observe: function () {
        document.querySelectorAll('.tropic-reveal:not(.tropic-in)').forEach(function (el) {
          obs.observe(el);
        });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', window._tropicReveal.observe);
    } else {
      window._tropicReveal.observe();
    }

    document.addEventListener('shopify:section:load', window._tropicReveal.observe);
  } else {
    window._tropicReveal.observe();
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tropic-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  var _scroll = null;

  function mount(headerEl) {
    if (_scroll) window.removeEventListener('scroll', _scroll);
    function tick() {
      headerEl.classList.toggle('tropic-header--scrolled', window.scrollY > 8);
    }
    _scroll = tick;
    window.addEventListener('scroll', tick, { passive: true });
    tick();

    var burger = headerEl.querySelector('.tropic-header__burger');
    var drawer = headerEl.querySelector('.tropic-header__drawer');
    if (burger && drawer) {
      burger.addEventListener('click', function () {
        var open = burger.getAttribute('aria-expanded') === 'true';
        burger.setAttribute('aria-expanded', String(!open));
        burger.setAttribute('aria-label', open ? 'Abrir menú' : 'Cerrar menú');
        if (open) {
          drawer.setAttribute('hidden', '');
        } else {
          drawer.removeAttribute('hidden');
        }
      });
    }
  }

  function init() {
    var el = document.querySelector('.tropic-header');
    if (el) mount(el);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var el = evt.target.querySelector('.tropic-header');
    if (el) mount(el);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tropic-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setOffset(el) {
    var top = el.getBoundingClientRect().top + window.scrollY;
    el.style.setProperty('--tropic-hero-offset', Math.max(0, Math.round(top)) + 'px');
  }

  function mount(el) {
    setOffset(el);
    var ro = function () { setOffset(el); };
    window.addEventListener('resize', ro, { passive: true });
    window.addEventListener('load', ro, { passive: true });
  }

  function init() {
    var el = document.querySelector('.tropic-hero');
    if (el) mount(el);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var el = evt.target.querySelector('.tropic-hero');
    if (el) mount(el);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tropic-manifesto"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!window._tropicReveal) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('tropic-in');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });

    window._tropicReveal = {
      observe: function () {
        document.querySelectorAll('.tropic-reveal:not(.tropic-in)').forEach(function (el) {
          obs.observe(el);
        });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', window._tropicReveal.observe);
    } else {
      window._tropicReveal.observe();
    }

    document.addEventListener('shopify:section:load', window._tropicReveal.observe);
  } else {
    window._tropicReveal.observe();
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tropic-newsletter"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!window._tropicReveal) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('tropic-in');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });

    window._tropicReveal = {
      observe: function () {
        document.querySelectorAll('.tropic-reveal:not(.tropic-in)').forEach(function (el) {
          obs.observe(el);
        });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', window._tropicReveal.observe);
    } else {
      window._tropicReveal.observe();
    }

    document.addEventListener('shopify:section:load', window._tropicReveal.observe);
  } else {
    window._tropicReveal.observe();
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tropic-values"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (!window._tropicReveal) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('tropic-in');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.15 });

    window._tropicReveal = {
      observe: function () {
        document.querySelectorAll('.tropic-reveal:not(.tropic-in)').forEach(function (el) {
          obs.observe(el);
        });
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', window._tropicReveal.observe);
    } else {
      window._tropicReveal.observe();
    }

    document.addEventListener('shopify:section:load', window._tropicReveal.observe);
  } else {
    window._tropicReveal.observe();
  }
}());

  } catch(e) { console.error(e); }
})();
})();
